export default class PaginationResponse<T> {
  public items: T[] = []
  public totalItems: number = 0
}
